import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { deletePage } from '../../../store/actions/pageActions';

function DeletePageDialog({ open, onClose, accountId, siteId, page }) {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setError(null);
    setIsDeleting(true);

    try {
      await dispatch(deletePage({
        accountId,
        siteId,
        pageId: page.id,
      })).unwrap();
      
      onClose();
    } catch (error) {
      setError(error?.message || 'Failed to delete page');
    } finally {
      setIsDeleting(false);
    }
  };

  // Don't render if no page is selected
  if (!page) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Page</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete the following page?
          </Typography>
          <Typography variant="h6" color="error">
            {page.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            URL: /{page.slug}
          </Typography>
        </Box>

        <Alert severity="warning">
          This action cannot be undone. The page will be permanently deleted.
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button 
          onClick={onClose}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={20} /> : null}
        >
          Delete Page
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeletePageDialog; 